import { ApiService } from '../services/api_service';
import { ContextService } from '../services/context_service';
import { DataService } from '../services/data_service';
// import DialogWrapper2 from '../core/dialog/dialog_wrapper_v2';
import { IDs } from '../helpers/IDs';
import { isProduzierendesGewerbe } from './functions/getGewerk';
import { lazyInject } from '../services/inversify';
import { Main } from './Main';
import { MainFilterLoader } from './MainFIlterLoader';
// import { MainSelection } from './MainSelection';
import * as Moment from 'moment';
// import { Nachhaltigkeit } from '../bereiche/nachhaltigkeit/nachhaltigkeit';
import { processKennzahlenImport } from '../main/functions/processKennzahlenImport';
import * as React from 'react';
import { renderText } from '../bereiche/dateneingabe/assistent/assistent_helpers';
// import { StartTabs } from '../bereiche/start/StartTabs';
// import { StartWillkommen } from '../bereiche/start/StartWillkommen';
import { StartTabsHeader } from '../bereiche/start/StartTabsHeader';
// import { Steuer } from '../bereiche/steuer/Steuer';
import style from './main.less';
import { TriggerService } from '../core/trigger/trigger_service';
import { WSpinner } from '../core/elements/spinner/WSpinner';

interface MainContentProps extends React.ClassAttributes<any> {
    onRoutingChange: (routing: any) => void;
    routing: any;
    unternehmenSel: any;
    contentBlocked?: boolean;
    modulSelected: string;
    openModulSelection: () => void;
    renderUnternehmenAuswahl: () => JSX.Element;
    lang: string;
    setLanguage: (lang: string) => void;
    onModulSelection: (modul: string) => void;
    callbackData?: (data: any) => void;
    onProcessKennzahlenImportDone?: () => void;
}

interface MainContentState extends React.ClassAttributes<any> {
    data: any;
    showSpinner: boolean;
    loadProgress: number;
    standorte: any[];
    standortSelected: any;
    showStartupHinweis: boolean;
}

export class MainContent extends React.Component<MainContentProps, MainContentState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: undefined,
            showSpinner: false,
            standorte: undefined,
            standortSelected: undefined,
            showStartupHinweis: false,
            loadProgress: 0
        };
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.onProgressChange = this.onProgressChange.bind(this);
        this.setModulSelection = this.setModulSelection.bind(this);
        this.devFeaturesMap = require('../wips.config.js').devFeaturesMap || {};
    }

    private loader: MainFilterLoader;
    private startupHinweisShown = false;
    private startupHinweisClosed = false;
    private devFeaturesMap: any = {};

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.contextService.clear();
        this.load();
    }

    componentDidUpdate(prevProps: Readonly<MainContentProps>, prevState: Readonly<MainContentState>, snapshot?: any): void {
        if (!prevState.data && this.state.data) {
            if (this.apiService.isMainUser() || this.apiService.isMandantenUser()) {
                this.setLoginCount();
            }
        }

        // Bitte verwenden LANGUAGE_SELECTED, die Sprachauswahl an Komponenten zu übergeben, um dort ein Update auszulösen.
        if (this.state.data && this.props.lang !== prevProps.lang) {
            const data = this.state.data;
            data.LANGUAGE_SELECTED = this.props.lang;
            this.setState({ data });
        }
    }

    load(): void {
        this.setState({ showSpinner: true, loadProgress: 0, data: undefined }, () => {
            this.loader = new MainFilterLoader(this.onDataLoaded, this.onProgressChange);
            if (this.props.unternehmenSel) {
                this.apiService.setUnternehmenInternal(this.props.unternehmenSel);
            }
            this.loader.loadData();
        });
    }

    onDataLoaded(data: any): void {
        // console.log('Data Loaded:', data);
        let showStartupHinweis = false;
        const konfig = data[IDs.ENT_KONFIGURATION];
        if (!this.startupHinweisClosed && this.startupHinweisShown) {
            showStartupHinweis = true;
        } else {
            if (!konfig || konfig.length === 0 || konfig[0].start_hinweis === 'Ja') {
                if (!this.startupHinweisShown) {
                    showStartupHinweis = true;
                }
            }
        }
        if (!showStartupHinweis) {
            this.startupHinweisClosed = true;
        }
        this.startupHinweisShown = true;
        data.RES_MAIN_LOAD_UNTERNEHMEN_SEL = this.props.unternehmenSel;
        data.MODUL_SELECTED = ((konfig || [])[0] || {}).dateneingabe_variante || this.props.modulSelected;
        data.MODUL_ON_SELECT = this.setModulSelection;
        const firstRound = !this.state.data;
        this.setState(
            {
                data: data,
                showSpinner: false,
                standorte: data[IDs.ENT_STANDORT],
                showStartupHinweis
            },
            () => {
                // WKETOOL-127 - Bugfix: “Mandanten ablaufen” - Verdoppelte Kennzahlen mit falsch zugeordneter Unternehmen-Tid.
                // Hinweis: Wegen processWitterung() kann Callback onDataLoaded mehrmals abgerufen werden, was die verdoppelte Kennzahlen mit processKennzahlenImport() erstellt.
                if (firstRound) {
                    processKennzahlenImport(data, this.dataService, this.props.onProcessKennzahlenImportDone);
                }
            }
        );

        if (typeof this.props.callbackData === 'function') {
            this.props.callbackData(data);
        }
    }

    isModulSteuerDisabled() {
        // const isAdmin = this.apiService.isAdmin();
        // if (!isAdmin && !this.devFeaturesMap.N233_STROM_ENERGIESTEUER) {
        //     alert('Das Modul zur Strom- und Energiesteuerrückerstattung befindet sich aktuell noch in Arbeit. Sie können diese Funktion über das E-Tool classic bereits eingeschränkt nutzen. Schauen Sie alternativ in wenigen Wochen wieder hier vorbei.');
        //     return true;
        // }
        const isProduGewebe: boolean = isProduzierendesGewerbe(this.state.data);
        const unternehmens = (this.state.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
        // console.log(wzobject, unternehmens);
        if (unternehmens.wz_tid && !isProduGewebe) {
            alert(`Sie haben zuvor in den Unternehmensdaten das Gewerk „${unternehmens.wz_tid}“ ausgewählt. Dieses Gewerk wird nicht dem produzierenden Gewerbe zugerechnet. Daher ist eine Strom- und Energiesteuerrückerstattung für Sie nicht möglich. Überprüfen Sie bitte ggf. Ihre Angaben in „Unternehmensdaten“ nochmal!`);
            return true;
        }
        return false;
    }

    setModulSelection(modul: string): void {
        const data = this.state.data;
        // console.log(data.MODUL_SELECTED, '->', modul);
        if (modul === 'steuer' && this.isModulSteuerDisabled()) {
            return;
        }
        if (data.MODUL_SELECTED !== modul) {
            data.MODUL_SELECTED = modul;
            this.setState({ data }, () => {
                this.props.onModulSelection(modul);
                const konfig: any = (this.state.data[IDs.ENT_KONFIGURATION] || [])[0] || {};
                if (konfig?.tid > 0 && konfig.dateneingabe_variante !== modul) {
                    const data: any = {
                        tid: konfig.tid,
                        dateneingabe_variante: modul
                    };
                    if (modul === 'cfm') {
                        data.co2_fussabdruck_modus = 'ghg';
                    }
                    if (modul === 'steuer') {
                        // Das Steuermodul erzwingt die Verwendung des geführten Modus.
                        data.gefuehrter_modus = 1;
                    }
                    this.dataService.saveData(IDs.ENT_KONFIGURATION, data, null, null, (suc: boolean) => {
                        if (suc) {
                            this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
                        }
                    }, IDs.MOD_ETOOL);
                }
            });
        } else {
            this.props.onModulSelection(modul);
        }
    }

    setLoginCount(): void {
        const { data } = this.state;
        if (Array.isArray(data[IDs.ENT_REGISTRIERUNG]) && data[IDs.ENT_REGISTRIERUNG].length > 0) {
            const regi = data[IDs.ENT_REGISTRIERUNG][0];
            if (regi.mandant_key) {
                this.dataService.loadData(
                    IDs.ENT_USER_LOGIN, { name: regi.mandant_key }, { fieldList: 'tid, anzahl, datum' },
                    (res: any) => {
                        const login: any = (res[IDs.ENT_USER_LOGIN] || [])[0] || {};
                        const anzahl: number = +login.anzahl || 0;
                        const tid: number = +login.tid || 0;
                        const stamp: number = +login.datum || 0;
                        // console.log(Moment().format('DD.MM.YYYY'), '/', Moment.unix(stamp).format('DD.MM.YYYY'));
                        if (Moment().format('DD.MM.YYYY') !== Moment.unix(stamp).format('DD.MM.YYYY')) {
                            this.dataService.setData(
                                IDs.MOD_ETOOL_ADMIN, IDs.ENT_USER_LOGIN,
                                { tid, name: regi.mandant_key, datum: Moment().unix(), anzahl: anzahl + 1 }
                            );
                        }
                    },
                    IDs.MOD_ETOOL_ADMIN
                );
            }
        }
    }

    onProgressChange(progress: number): void {
        this.setState({ loadProgress: progress });
    }

    reloadData(): void {
        this.load();
    }

    render(): JSX.Element {
        // console.log('Data', this.state.data);
        if (Main.autoWalkToNextTool) {
            return <div>
                <div
                    style={{ marginTop: 70, textAlign: 'center' }}>
                    <div>Die Tools werden nun automatisch abgelaufen.</div>
                    <div style={{ fontWeight: 'bold', marginTop: 20 }}>
                        {`${Main.autoWalk.unternehmen.bezeichnung} (${Main.autoWalk.index + 1} von ${Main.autoWalk.length})`}
                    </div>
                    <button
                        style={{ padding: 10, marginTop: 20 }}
                        onClick={() => {
                            const currentPage = new URL(window.location.href);
                            currentPage.searchParams.set('t', (new Date().getTime()) + '');
                            window.location.href = currentPage.href;
                        }}>Abbrechen</button>
                </div>
                <WSpinner label={`${this.state.loadProgress > 100 ? 100 : this.state.loadProgress}%`} />
            </div>;
        }

        if (!this.state.data || Object.keys(this.state.data).length === 0) {
            const spinText = this.state.loadProgress > 97 ? 'Starte' : `${this.state.loadProgress}%`;
            return <WSpinner label={spinText} />;
        }

        if (this.props.contentBlocked) {
            return <div style={{ padding: 20 }}> {renderText('Sperrtext', this.state.data)}</div>;
        }

        return (
            <>
                <div className={style.mainContentBox} style={{ height: '100%' }}>
                    {/* {this.props.modulSelected === 'selection' &&
                        <MainSelection
                            modulSelected={this.props.modulSelected}
                            data={this.state.data}
                            onModulSelection={(modul: string) => this.setModulSelection(modul)}
                        />
                    } */}
                    {(['cfm', 'classic', 'nachhaltigkeit', 'selection', 'steuer', 'vsme'].indexOf(this.props.modulSelected) !== -1) &&
                        <StartTabsHeader
                            key={`ST_${this.apiService.getMandantKey()}`}
                            data={this.state.data}
                            onRoutingChange={this.props.onRoutingChange}
                            reloadData={this.reloadData}
                            routing={this.props.routing}
                            lang={this.props.lang}
                            setLanguage={this.props.setLanguage}
                            modulSelected={this.props.modulSelected}
                            openModulSelection={this.props.openModulSelection}
                            renderUnternehmenAuswahl={this.props.renderUnternehmenAuswahl}
                            standortSelected={this.state.standortSelected}
                        />
                    }
                    {/* {this.props.modulSelected === 'nachhaltigkeit' &&
                        <Nachhaltigkeit data={this.state.data} />
                    } */}
                    {/* {this.props.modulSelected === 'steuer' &&
                        <Steuer data={this.state.data} />
                    } */}
                </div>
            </>
        );
    }
}
